export class EntReportReservoirHistory {
    startDate: string;
    endDate: string;
    languageEnum: string;

    constructor(startDate: string = '', endDate: string = '', languageEnum: string = '') {
        this.startDate = startDate;
        this.endDate = endDate;
        this.languageEnum = languageEnum;
    }
}